<!-- eslint-disable vue/no-unused-properties -->
<script setup lang="ts">
import { useAttrs } from 'vue';
import { BaseInputField } from '@/interfaces/InputFields';

const model = defineModel();

defineProps<
  BaseInputField & {
    autofocus?: boolean;
    disabled?: boolean;
    valid: boolean;
    centered?: boolean;
  }
>();
const attrs = useAttrs();
</script>

<template>
  <input
    :id="name"
    v-model="model"
    :type="type"
    :disabled="disabled"
    :required="required"
    :autofocus="autofocus"
    :autocomplete="label"
    :maxlength="maxlength"
    :placeholder="(attrs.placeholder as string)"
    class="Field peer"
    :class="[
      `Field--${type}`,
      {
        'Field--invalid': !valid,
      },
    ]"
  />
</template>
